import React, { useEffect } from 'react';
 
import { useModal } from 'src/hooks/Modal';
import { BigDescription, BigTitle, BlockContainer, BlockContainerModal, Image, Paragraph, TextContainer, Title } from './styles';
import { useConfiguration } from 'src/hooks/Configuration';
import useSpeakersHook from './hooks/speakers';
import { EditableDiv } from '../../../styles';
import SocialShare from '../components/ShareOptions';
import SocialShareSpeaker from './modules/SocialShare';
import SpeakerModal from './modules/SpeakerModal';
import { websitePath } from 'src/config';

interface IProps {
    list: Record<string, any>;
    computer: Record<string, any>;
    mobile: Record<string, any>;
    component_styles?: Record<string, any>;
      configs?: Record<string, any>;
}


const DataLine = ({ component_styles, configs, item, computer, mobile }: any) => {
  const {configuration } = useConfiguration();
 
    const { addModal } = useModal();

 


    const openPopup = (content) => {
    
        addModal({
           title: '', content: <SpeakerModal component_styles={component_styles} content={content}/>, key: 'popupmodal', theme: 'whiteModalMedium'
        })

    }

    return <BlockContainer onClick={ () => configs?.show_modal === 'Sim' ? openPopup(item) : false } className='column' component_styles={component_styles} >
        <div style={{width: '100%', position:'relative'}}>
            {item?.photo ? <Image src={`${websitePath}/${item?.photo}`} component_styles={component_styles} /> : <></>}
        <div style={{position: 'absolute', bottom:'0px', left: '0px', width: '100%'}}>
           {item?.social ? <SocialShareSpeaker color='#fff' size={"20"} socialIcons={item?.social}/> : <></>}
       </div>
       </div>
        <TextContainer component_styles={component_styles}>
            <Title component_styles={component_styles} dangerouslySetInnerHTML={{ __html: item?.name }} />
            {configs?.show_short_description === 'Sim' && item?.short_description ? <Paragraph component_styles={component_styles} dangerouslySetInnerHTML={{ __html: item?.short_description }} /> : <></>}
            {configs?.show_description === 'Sim' && item?.description ? <Paragraph component_styles={component_styles} dangerouslySetInnerHTML={{ __html: item?.description }} /> : <></>}
          </TextContainer>
    </BlockContainer>

}

const SpeakerWidget: React.FC<IProps> = ({ component_styles, configs,  computer, mobile }) => {

    computer['flex-wrap'] = 'wrap';

       const {speakers, loadSpeakers} = useSpeakersHook();

    useEffect(() => {
 
        loadSpeakers()

    },[])

 

    return (<>{
       speakers?.map( container => {

   return <div className='column-start'>
            <BigTitle component_styles={component_styles}>{container?.title}</BigTitle>
            { container?.description ? <BigDescription component_styles={component_styles} dangerouslySetInnerHTML={{__html: container?.description}}/>  : <></>}
            <EditableDiv computer={computer} mobile={mobile}>
  {container?.speakers?.map(item => <DataLine configs={configs} item={item} component_styles={component_styles} computer={computer} mobile={mobile} />)}
  
 </EditableDiv>
 </div>
        })}
     

 

    </>);
};
export default SpeakerWidget;
